import React from "react";
import {Provider} from "react-redux";
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import "animate.css";
import 'Ncontracts.Common.UI/dist/bundle.css';
import 'bulma';
import './styles/_site.scss';
import configureStore from "./store/configureStore";
import {hotjar} from 'react-hotjar';
import settings from './configs/appSettings';
import CommunicationsContainer from "./components/communications/CommunicationsContainer";
import PageNotFoundPage from "./components/common/errorPages/404";
import PollPortalContainer from "./components/pollPortal/PollPortalContainer";

const store = configureStore();

hotjar.initialize(parseInt(settings.hotjarId));

export default function App() {
	return <Provider store={store}>
		<Router>
			<Switch>
				<Route path="/pollPortal" component={PollPortalContainer}/>
				<Route path="/" component={CommunicationsContainer}/>
				<Route component={PageNotFoundPage}/>
			</Switch>
		</Router>
	</Provider>;
}
